<template>
    <v-app id="app">
        <router-view></router-view>
    </v-app>
</template>

<script>


    /*import DiezForm from './components/DiezForm'*/
    export default {
        name: 'app',
        props: ['prueba'],
        data() {
            return {}
        },
       /* components: {
            rHeader: HeaderComponent,
            /!*diezForm: DiezForm*!/
        }*/
    }
</script>

<style lang="scss">
    @import './_static/base';
    #app {
        background-image: url(assets/fondo.jpg);
        background-repeat: no-repeat;
        background-size: cover;
        background-color: white;
        min-height: 100vh;
        padding-top: 2rem;
    }


    .formulario {
        background-color: white;
    }

    .main-content, .main-footer {
        background-color: white;
        width: 90vw;
        margin: 0 auto;

    }
    .main-content {
        border-radius: 15px 15px 0 0;
    }

    h1 {
        font-family: $fonts;
    }


    // Tablets
    @media (min-width: 768px) and (max-width: 1024px) {
        .main-content, .main-footer {
            background-color: peru;

        }
    }

    // Pantallas
    @media (min-width: 1200px) {
        .main-content, .main-footer {
            width: 80vw;
            max-width: 1140px;
        }
        .main-footer {
            margin: 0 auto;
            padding: 1rem;
        }
        .main-header {
            width: 80vw;
            max-width: 1140px;
            margin: 0 auto;
        }
    }

</style>